import { mapActions } from 'vuex';

export default {
  props: {
    topic: {
      type    : Object,
      default : () => ({})
    },
    isOpenOnBottomSheet: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      isGettingRecords            : false,
      records                     : [],
      academicMainId              : this.$route.params.courseId,
      panel                       : [],
      alreadyLoadedWebconferences : false
    };
  },
  methods: {
    ...mapActions({
      actionGetWebConferenceRecords   : 'plataforma/newContent/actionGetWebconferenceRecords',
      actionGetWebConferenceRecordURL : 'plataforma/newContent/actionGetWebconferenceRecordURL',
      actionAddProgress               : 'plataforma/newContent/actionAddProgress'
    }),
    async getWebConferenceRecords() {
      if (!this.isGettingRecords && !this.alreadyLoadedWebconferences) {
        this.isGettingRecords = true;

        this.actionGetWebConferenceRecords({
          academicMainId : this.academicMainId,
          topicId        : this.topic.id
        })
          .then(async data => {
            this.records = data.results;

            for (const record of this.records) {
              const { url } =  await this.actionGetWebConferenceRecordURL({
                academicMainId : this.academicMainId,
                topicId        : this.topic.id,
                recordId       : record.id
              });

              record.url = url;
            }
          })
          .catch(() => {
            this.records = [];
            this.$toast.error(this.$t('contentType.webconference.errorOnAccessRecord'));
          }).finally(() =>{
            this.isGettingRecords = false;
            this.alreadyLoadedWebconferences = true;
            this.$emit('updatedWebConferece');
          });
      } else {
        this.$nextTick(() => {
          this.$emit('updatedWebConferece');
        });
      }
    },
    downloadRecord(recordId) {
      if (!recordId) {
        return;
      }

      this.$nuxt.$loading.start();
      this.actionGetWebConferenceRecordURL({
        academicMainId : this.academicMainId,
        topicId        : this.topic.id,
        recordId       : recordId,
        isDownload     : true
      })
        .then(data => {
          if (!data.url) {
            throw new Error();
          }

          this.markTopicProgress();

          window.open(data.url, '_blank');
        })
        .catch(() => {
          this.$toast.error(this.$t('contentType.webconference.errorOnDownloadRecord'));
        })
        .finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    markTopicProgress() {
      if (!this.topic || this.topic.viewed) {
        return;
      }

      this.actionAddProgress({
        academicMainId : this.academicMainId,
        topicId        : this.topic.id
      })
        .catch((error) => {
          this.$toast.error(error);
        });
    }
  }
};
